import React from 'react';
import withModal, { WithModalProps } from 'hoc/with-modal';
import { useTranslation } from 'i18n';
import { CheckIcon, ModalContent } from 'routes/auth/style';
import { H2, H3 } from 'components/typography';
import { CloseModalIcon } from 'components/icons';
import { Row } from 'components/layout';

export interface ForgotPasswordSuccessModalProps extends WithModalProps {}

function ForgotPasswordSuccessModal(props: ForgotPasswordSuccessModalProps) {
  const { t } = useTranslation();

  return (
    <>
      <CloseModalIcon onClick={props.modal.hide} />
      <H2>{t('Reset password')}</H2>
      <ModalContent>
        <Row>
          <CheckIcon />
          <H3>
            {t(
              'You have received and email to reset your password. Please check your email inbox and spam folder.',
            )}
          </H3>
        </Row>
      </ModalContent>
    </>
  );
}

export default withModal(ForgotPasswordSuccessModal);
